import ParcelDetail from 'components/ParcelDetail';
import { createContext, useContext, useEffect, useState } from 'react';

const ParcelContext = createContext(null);

export function useParcel() {
  return useContext(ParcelContext);
}

const PRICE_API = 'https://price-api.crypto.com/price/v1/exchange/decentraland';
const TILES_API = 'https://api.decentraland.org/v1/tiles';

export default function ParcelProvider({ children }) {
  const [price, setPrice] = useState(0);
  const [tiles, setTiles] = useState([]);
  const [parcelOpen, setParcelOpen] = useState(false);
  const [select, setSelect] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const response = await fetch(PRICE_API);
        const json = await response.json();
        setPrice(json?.fiat?.usd || 0);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchTiles = async () => {
      try {
        const response = await fetch(TILES_API);
        const json = await response.json();
        setTiles(json.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchTiles();
    fetchPrice();

    const priceInterval = setInterval(() => {
      fetchPrice();
    }, 30000);

    return () => {
      clearInterval(priceInterval);
    };
  }, []);

  const value = { price, tiles, parcelOpen, setParcelOpen, select, setSelect };

  return (
    <ParcelContext.Provider value={value}>
      {select && <ParcelDetail />}
      {children}
    </ParcelContext.Provider>
  );
}
